var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportsCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.411,
    height: 13.738,
    viewBox: "0 0 19.411 13.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sports-car",
    transform: "translate(0 -5.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(0 5.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M19.3,9.958a.5.5,0,0,0-.385-.183H17.025a6.44,6.44,0,0,0-1.764-2.889c-2.388-1.571-8.723-1.571-11.111,0A6.472,6.472,0,0,0,2.386,9.775H.5a.5.5,0,0,0-.487.6l.28,1.356a.5.5,0,0,0,.487.4h.56a3.356,3.356,0,0,0-.806,2.193,3.286,3.286,0,0,0,1.038,2.467l.022.017v1.9a.746.746,0,0,0,.746.746H4.079a.746.746,0,0,0,.746-.746v-.762h9.762V18.7a.746.746,0,0,0,.746.746h1.743a.747.747,0,0,0,.746-.746V16.84a3.41,3.41,0,0,0,.218-4.716h.6a.5.5,0,0,0,.487-.4l.28-1.355A.5.5,0,0,0,19.3,9.958ZM4.969,8.131c1.9-1.253,7.569-1.253,9.472,0a6.146,6.146,0,0,1,1.281,2.424H3.689A6.147,6.147,0,0,1,4.969,8.131ZM2.739,14.5a1.467,1.467,0,1,1,1.467,1.467A1.466,1.466,0,0,1,2.739,14.5Zm12.485,1.467A1.466,1.466,0,1,1,16.691,14.5,1.467,1.467,0,0,1,15.224,15.972Z",
    transform: "translate(0 -5.707)",
    fill: "#4e4e4e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsCar);
export default __webpack_public_path__ + "static/media/sports-car.c47385fbdb4960a16d4f4cdf5729b40f.svg";
export { ForwardRef as ReactComponent };